import styled from 'styled-components';

export const GroupingTableContainer = styled.div`
  padding: 16px;
`;

export const GroupingTableHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 8px;
`;

export const FileSwitcherWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
